/**
 * Frontend logger. Console-backed in dev. In production unhandled errors are
 * also reported to the API at POST /api/client-errors so they appear in the
 * server-side journald stream alongside backend logs (for the same request
 * id, when one is in scope).
 */
import { api } from './api'

interface LogContext {
  requestId?: string
  route?: string
  [key: string]: unknown
}

export function logError(message: string, err: unknown, ctx: LogContext = {}): void {
  const error = err instanceof Error ? err : new Error(String(err))
  console.error(`[collector] ${message}`, { error, ...ctx })
  if (import.meta.env.PROD) {
    void api()
      .axios.post('/client-errors', {
        message,
        stack: error.stack,
        name: error.name,
        ...ctx,
      })
      .catch((reportErr: unknown) => {
        // Keep the report failure visible — never silently drop.
        console.warn('[collector] failed to report client error', reportErr)
      })
  }
}
